import { createSelector } from 'reselect'
import { partial } from 'lodash'
import { selectLeverageableEquityForLTV80 } from './equity'
import { studentDebt } from '../../../../constants/equity'

export const selectStudentLoanPayDown = createSelector(
  selectLeverageableEquityForLTV80,
  partial(Math.min, studentDebt.average)
)
